module.exports = __webpack_public_path__ + "h5/img/videos.5a8e6dc1.png";